import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {
  Paper,
  PaperHeadline,
  PaperContent,
  Form,
  Text,
  Link,
  Icon,
  Button,
  Input,
  HeaderDivider,
  Checkbox
} from '../../'
import { PetsBestPaymentLogo } from '../SvgIcons'


export class SpreedlyPayment extends React.PureComponent {
  static propTypes = {
    petName: PropTypes.string,
    plan: PropTypes.string,
    annual: PropTypes.string,
    deductible: PropTypes.string,
    reimbursement: PropTypes.string,
    monthlyPrice: PropTypes.string,
    transactionFee: PropTypes.string,
    total: PropTypes.string,
    policyStartDate: PropTypes.string,
    accidentWaiting: PropTypes.string,
    illnessWaiting: PropTypes.string,
    cruciateWaiting: PropTypes.string,
    onFormSubmit: PropTypes.func,
    creditCardHolderNameInputFieldProps: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
      name: PropTypes.string,
      error: PropTypes.bool,
      hint: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      id: PropTypes.string
    }),
    creditCardExpiryInputFieldProps: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
      name: PropTypes.string,
      error: PropTypes.bool,
      hint: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      id: PropTypes.string
    }),
    creditCardNumberError: PropTypes.string,
    creditCardCVVError: PropTypes.string,
    errorMessage: PropTypes.string,
    goBackButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    payButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    agreementCheckboxProps: PropTypes.shape({
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),

    preExistingCheckboxProps: PropTypes.shape({
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    agreementModalProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    preExistingModalProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func
    }),
    samplePolicy: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    petName: 'Rachael',
    plan: 'Plus',
    annual: 'Unlimited',
    deductible: '$1,000',
    reimbursement: '90%',
    monthlyPrice: '$29.32',
    transactionFee: '$2.00',
    total: '$31.32',
    policyStartDate: 'December 4, 2025',
    accidentWaiting: '3 days (December 7, 2025)',
    illnessWaiting: '14 days (December 18, 2025)',
    cruciateWaiting: '6 months (June 4, 2025)'
  }

  render() {
    const {
      petName,
      plan,
      annual,
      deductible,
      reimbursement,
      monthlyPrice,
      transactionFee,
      total,
      policyStartDate,
      accidentWaiting,
      illnessWaiting,
      cruciateWaiting,
      creditCardHolderNameInputFieldProps,
      creditCardExpiryInputFieldProps,
      creditCardCVVError,
      creditCardNumberError,
      agreementCheckboxProps,
      preExistingCheckboxProps,
      agreementModalProps,
      preExistingModalProps,
      errorMessage,
      onFormSubmit,
      goBackButtonProps,
      payButtonProps,
      samplePolicy,
      id,
      style,
      refProp,
      className
    } = this.props

    return (
      <Paper
        id={id}
        className={cn("ui-spreedly-payment-card", className)}
        style={style}
        ref={refProp}
        type={Paper.Types.framed}
      >
        <PaperHeadline>Pet Insurance Add-Ons</PaperHeadline>

        <PaperContent>
          <Link href='https://www.petsbest.com/underwriters-licensing' target='_blank'>Underwriting</Link>
          <div className='ui-spreedly-payment-card__pet'>
            <Text>{petName}'s Plan</Text>
            <span {...goBackButtonProps}>
              Change Plan
            </span>
          </div>

          <div className='ui-spreedly-payment-card__price-details'>
            <div className='ui-spreedly-payment-card__coverage'>
              <Text className='ui-spreedly-payment-card__plan'>Coverage: {plan}</Text>
              <Text>Annual Coverage: {annual}</Text>
              <Text>Deductible: {deductible}</Text>
              <Text>Reimbursement: {reimbursement}</Text>
            </div>
            <div className='ui-spreedly-payment-card__price-break-up'>
              <Text className='ui-spreedly-payment-card__plan'>Plan</Text>
              <Text>
                <span>{petName}</span>
                <span>{monthlyPrice}</span>
              </Text>
              <HeaderDivider />
              <Text>
                <span>Transaction Fee</span>
                <span>{transactionFee}</span>
              </Text>
              <Text>
                <span>Monthly total</span>
                <span className='ui-spreedly-payment-card__total'>{total}</span>
              </Text>
            </div>
          </div>
          <Form onSubmit={onFormSubmit} id='spreedly-form'>
            <div className='ui-spreedly-payment-card__payment-info'>
              <Text type={Text.Types.headline}>Payment Information</Text>
              {errorMessage && (
                <Text
                  type={Text.Types.bodyBold}
                  className='ui-spreedly-payment-card__error'
                >
                  {errorMessage}
                </Text>
              )}
              <Input
                label='Name On Card'
                {...creditCardHolderNameInputFieldProps}
              />
              <div className='ui-spreedly-payment-card__credit__row'>
                <div className='ui-spreedly-payment-card__iframe'>
                  <label>Credit Card Number</label>
                  <div label='Credit Card Number' id="spreedly-number" ></div>
                  {creditCardNumberError && (<Text className='ui-spreedly-payment-card__error' type={Text.Types.caption}>
                    {creditCardNumberError}
                  </Text>)}
                </div>
                <PetsBestPaymentLogo />
              </div>

              <div className='ui-spreedly-payment-card__form__row'>
                <Input label='Expiration Date' {...creditCardExpiryInputFieldProps} />
                <div className='ui-spreedly-payment-card__iframe'>
                  <label>CVV</label>
                  <div label='Security Code' id="spreedly-cvv" ></div>
                  {creditCardCVVError && (<Text className='ui-spreedly-payment-card__error' type={Text.Types.caption}>
                    {creditCardCVVError}
                  </Text>)}
                </div>
              </div>

              <div className="ui-spreedly-payment-card__secure">
                <Icon type='lock_outlined' />
                <span>All transactions are securely encrypted</span>
              </div>
            </div>

            <div className='ui-spreedly-payment-card__policy'>
              <Text type={Text.Types.headline}>Policy Start Date</Text>
              <div className='ui-spreedly-payment-card__policy-info'>
                <Text>When you enroll today, your police effective date will be:</Text>
                <Text>
                  {policyStartDate}
                </Text>
              </div>
            </div>

            <div className='ui-spreedly-payment-card__policy'>
              <Text type={Text.Types.headline}>Waiting Periods</Text>
              <div className='ui-spreedly-payment-card__policy-info'>
                <Text>Accidents:</Text>
                <Text>{accidentWaiting}</Text>
              </div>
              <div className='ui-spreedly-payment-card__policy-info'>
                <Text>Illnesses:</Text>
                <Text>{illnessWaiting}</Text>
              </div>
              <div className='ui-spreedly-payment-card__policy-info'>
                <Text>Cruciate ligament conditions:</Text>
                <Text>{cruciateWaiting}</Text>
              </div>
            </div>
            <div className='ui-spreedly-payment-card__checkboxes'>
              <div>
                <Checkbox
                  showPetplaceCheckbox={true}
                  {...agreementCheckboxProps}
                />
                <p>I agree to the terms of the <span {...agreementModalProps}>Application Agreement</span></p>
              </div>
              <div>
                <Checkbox
                  showPetplaceCheckbox={true}
                  {...preExistingCheckboxProps}
                />
                <p>I understand that <span {...preExistingModalProps}>pre-existing conditions</span>  will not be covered</p>
              </div>
            </div>

            <div className='ui-spreedly-payment-card__actions'>
              <p {...goBackButtonProps}>
                Go Back
              </p>
              <Button color={Button.Colors.tertiary} {...payButtonProps}>
                Submit Payment & Continue
              </Button>
            </div>
          </Form>
          <div className='ui-spreedly-payment-card__verbiage'>
            <Text>
              The insurance plans available through this agency are limited to specific plan types.
              For additional plan options offered by Pets Best Insurance Services, LLC, please visit <Link href='https://www.petsbest.com' target='_blank'>www.petsbest.com</Link>
            </Text>
            <Text>
              View a <Link href={samplePolicy} target='_blank'>Sample Policy</Link>
            </Text>
            <Text>
              PetPlace is Powered by PTZ Insurance Agency, Ltd (NPN: 5328528; CA licensed: 0E36937) a licensed insurance agency that
              does not underwrite pet insurance or pay claims but receives compensation on sale and/or renewal.
            </Text>
            <Text>
              Waiting periods, annual deductible, co-insurance, benefit limits, and exclusions may apply.
              For all terms visit <Link href='https://www.petsbest.com/policy' target='_blank'>www.petsbest.com/policy</Link>. Products, schedules, discounts, and rates may vary and are
              subject to change. More information is available at checkout.
              Premiums are based on and may increase or decrease due to the age of your pet, the species or breed of your
              pet, and your home address.
            </Text>
            <Text>
              Pet insurance coverage offered and administered by Pets Best Insurance Services,
              LLC is underwritten by American Pet Insurance Company (NAIC #12190), a New York insurance company
              headquartered at 6100 4th Ave. S. Suite 200 Seattle, WA 98108, or Independence American Insurance Company
              (NAIC #26581), a Delaware insurance company located at 11333 N.
              Scottsdale Rd, Ste. 160, Scottsdale, AZ 85254. Pets Best Insurance Services,
              LLC (NPN #8889658, CA agency #0F37530) is a licensed insurance agency located at 10840 Ballantyne
              Commons Parkway, Charlotte, NC 28277. Each insurer has sole financial responsibility for its own products.
              Please refer to your declarations page to determine the underwriter for your policy.
              Terms and conditions apply. See policy for details.
            </Text>
          </div>
        </PaperContent>
      </Paper>
    )
  }
}
